import { render, staticRenderFns } from "./PlayerInsightsTable.vue?vue&type=template&id=4fcf0c5a"
import script from "./PlayerInsightsTable.vue?vue&type=script&lang=js"
export * from "./PlayerInsightsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports